import { jsx as _jsx } from "react/jsx-runtime";
import { VisibleColumnType } from "@air/api/types";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { memo, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useKanbanContext } from "~/components/KanbanView/Providers/KanbanProvider";
import { hideKanbanColumnAction } from "~/store/configViews/actions";
import { currentKanbanGroupByCustomFieldIdSelector } from "~/store/configViews/selectors";
import { kanbanColumnItemCountSelector, kanbanColumnNeedsToLoadItemsSelector, kanbanColumnSortableKeysSelector } from "~/store/kanbanManager/selectors";
import { getSortableContextKanbanColumnItemsKey } from "~/utils/getDndKeys";
import { useAirSelector } from "~/utils/ReduxUtils";
import { KanbanColumnHeader } from "../../../shared/KanbanColumnHeader";
import { KanbanColumnItems } from "../../../shared/KanbanColumnItems/KanbanColumnItems";
import { DndDroppableKanbanColumn } from "./DndDroppableKanbanColumn";
export const DndSortableContextKanbanColumn = /*#__PURE__*/ memo((param)=>{
    let { kanbanColumnId, dndListeners } = param;
    const { customFieldValues } = useKanbanContext();
    const kanbanItemsCount = useAirSelector((state)=>kanbanColumnItemCountSelector(state, kanbanColumnId));
    const customFieldId = useAirSelector(currentKanbanGroupByCustomFieldIdSelector);
    const dispatch = useDispatch();
    const sortableKeys = useAirSelector((state)=>kanbanColumnSortableKeysSelector(state, kanbanColumnId));
    const isLoading = useAirSelector((state)=>kanbanColumnNeedsToLoadItemsSelector(state, kanbanColumnId));
    const colHeaderProps = useMemo(()=>{
        const props = {
            onHideColumn: ()=>dispatch(hideKanbanColumnAction({
                    kanbanColumnId
                })),
            itemCount: kanbanItemsCount,
            id: "no-".concat(customFieldId),
            label: "None",
            color: "transparent",
            dndListeners
        };
        if (kanbanColumnId !== VisibleColumnType.unassignedCustomFieldValue) {
            const cfValue = customFieldValues === null || customFieldValues === void 0 ? void 0 : customFieldValues.find((cfVal)=>cfVal.id === kanbanColumnId);
            if (cfValue) {
                props.id = cfValue.id;
                props.label = cfValue.value;
                props.color = cfValue.color.name;
                props.itemCount = kanbanItemsCount;
            }
        }
        return props;
    }, [
        dispatch,
        kanbanColumnId,
        customFieldId,
        customFieldValues,
        kanbanItemsCount,
        dndListeners
    ]);
    if (!customFieldId) return null;
    return /*#__PURE__*/ _jsx(DndDroppableKanbanColumn, {
        isLoading: isLoading,
        kanbanColumnId: kanbanColumnId,
        header: /*#__PURE__*/ _jsx(KanbanColumnHeader, {
            ...colHeaderProps
        }),
        children: /*#__PURE__*/ _jsx(SortableContext, {
            id: getSortableContextKanbanColumnItemsKey(kanbanColumnId),
            items: sortableKeys,
            strategy: verticalListSortingStrategy,
            children: /*#__PURE__*/ _jsx(KanbanColumnItems, {
                kanbanColumnId: kanbanColumnId
            })
        })
    });
});
DndSortableContextKanbanColumn.displayName = "DndSortableContextKanbanColumn";
